"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hexToRGB(hex, alpha) {
    if (alpha === void 0) { alpha = 1; }
    var colorString = hex.startsWith("#") ? hex.slice(1) : hex;
    var red = colorString.slice(0, 2);
    var green = colorString.slice(2, 4);
    var blue = colorString.slice(4, 6);
    return "rgba(" + parseInt("0x" + red, 16) + ", " + parseInt("0x" + green, 16) + ", " + parseInt("0x" + blue, 16) + ", " + alpha + ")";
}
exports.hexToRGB = hexToRGB;
//# sourceMappingURL=hex-to-rgb.js.map